import { render } from "./MyProfileMenuLayout.vue?vue&type=template&id=5e430252"
import script from "./MyProfileMenuLayout.vue?vue&type=script&lang=js"
export * from "./MyProfileMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__